module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('h1', {
    staticClass: "toc_h"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253053053_Preface#pre",
      "id": "spre"
    }
  }, [_c('i', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253053053_Introduction#intro",
      "id": "sintro"
    }
  }, [_vm._v("Introduction: Anthem of a Generation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_be"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253053053_Chapter01#ch1",
      "id": "sch1"
    }
  }, [_c('span', {
    staticClass: "toc-pad"
  }, [_vm._v("1.")]), _vm._v(" Songs Rather Than Screams")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_be"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253053053_Chapter02#ch2",
      "id": "sch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-pad"
  }, [_vm._v("2.")]), _vm._v(" Something That Is Ours . . . and Still Authentically Islam")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_be"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253053053_Chapter03#ch3",
      "id": "sch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-pad"
  }, [_vm._v("3.")]), _vm._v(" It Is … a Problem of Human Rights")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_be"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253053053_Chapter04#ch4",
      "id": "sch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-pad"
  }, [_vm._v("4.")]), _vm._v(" She Reppin’ Islam and She Gives It a Meaning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_be"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253053053_Chapter05#ch5",
      "id": "sch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-pad"
  }, [_vm._v("5.")]), _vm._v(" Enemy of the State")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_be"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253053053_Chapter06#ch6",
      "id": "sch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-pad"
  }, [_vm._v("6.")]), _vm._v(" Keeping It Real … Keeping It Cool")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_ent"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253053053_References#ref",
      "id": "sref",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("References")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_en"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253053053_Index#index",
      "id": "sindex",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0f3e682","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253053053_Contents.vue
// module id = 72
// module chunks = 0